//
//  customers.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

export default abstract class Customers {

    public static getList(context: string): string[] {

        return context === 'cineseries' ? [
            'customers_mars_project',
            'customers_nolita',
            'customers_enki',
            'customers_playtime',
            'customers_22h22',
            'customers_pierre_morel',
            'customers_elephant',
            'customers_oeil_productions',
            'customers_f_comme_film',
            'customers_cellquest',
            'customers_mamie_cocotte',
        ] : [
            'customers_cellquest',
            'customers_mamie_cocotte',
            'customers_enki',
            'customers_playtime',
            'customers_22h22',
            'customers_pierre_morel',
            'customers_elephant',
            'customers_oeil_productions',
            'customers_f_comme_film',
            'customers_mars_project',
            'customers_nolita',
        ];

    }

}
